---
title: My First Self-Created Sudoku
date: '2025-09-23'
excerpt: First day of vacation and after bingewatching CrackingTheCryptic on YouTube, I created a basketball-themed sudoku puzzle. Can you guess the sports team?
metaTitle: My First Basketball-Themed Sudoku Puzzle | Kevin Rassner
metaDescription: A custom basketball-themed sudoku puzzle inspired by CrackingTheCryptic. Test your puzzle-solving skills and see if you can guess the sports team without solving!
language: en
slug: my-first-sudoku
author: Kevin Rassner
linkedinUrl: https://www.linkedin.com/posts/kevin-rassner_guess-the-sports-team-by-kevinrassner-svens-activity-7368560904738676736-EoAD?utm_source=share&utm_medium=member_desktop&rcm=ACoAABOVTMUBYXTIxIvCDnvaQZ6lrRF9KkXF3WM
isLinkedInPost: true
---

First day of vacation and after bingewatching CrackingTheCryptic on youtube I found out that there are no basketball themed sudokus. So I used transit wait times and created one. Give it a go and let me know if it's good enough for Simon Anthony and Mark Goodliffe :) To all Basketball fans, you might be able to guess the answer without solving ;)

https://lnkd.in/ebvFuPR6

